import { useState, useEffect } from "react";
import API from "../api";
import { AxiosResponse } from "axios";
import CommonButton from "../components/CommonButton";
import {
  Empty,
  Table,
  Select,
  Input,
  Drawer,
  Space,
  Switch,
  InputNumber,
} from "antd";
import style from "../style/twoColForm.module.scss";
import partnerHubs from "./partnerHubs.module.scss";
import { DeleteTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import {
  StationInterface,
  defaultStationData,
  stationCol,
  timeFormate,
  WeekDays,
} from "../Admin/partnersConst";
import {
  antdMessageError,
  antdMessageSuccess,
} from "../utils/antdMessageComponent";
import {
  AllowInputType,
  handleNumericInput,
  isValidEmail,
} from "../utils/ValidationReg";
const PartnerHubs = ({ id }: { id: any }) => {
  const [data, setData] = useState([] as StationInterface[]);
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("create" as "edit" | "create");
  const [cityData, setCityData] = useState(
    [] as { _id: string; name: string }[]
  );
  const [activeStationData, setActiveStationData] = useState(
    defaultStationData as StationInterface
  );
  const [errors, setErrors] = useState<any>({});

  useEffect(() => {
    (async () => {
      if (open) return;

      const cities = await API.admin.GetCities();
      if (!API.validators.checkSuccessCode(cities)) return;

      const modifiedCityData = cities.data?.data?.map((item: any) => {
        return {
          value: item?._id,
          label: item?.name,
        };
      });

      setCityData(modifiedCityData);
    })();
  }, [id, open]);

  const onClose = () => {
    setOpen(false);
  };

  const onstationEdit = (value: StationInterface) => {
    setMode("edit");
    setActiveStationData({ ...value, partner: id });
    setOpen(true);
  };

  const createStation = () => {
    setMode("create");
    setActiveStationData({ ...defaultStationData, partner: id });
    setOpen(true);
  };

  useEffect(() => {
    if (!id) return;

    if (open) return;

    (async () => {
      const stations = await API.admin.GetStations({ _id: id });

      if (!API.validators.checkSuccessCode(stations))
        return antdMessageError("Unable to fetch statiobs");

      const modifyStationData = [] as any;
      const stationResponse = stations.data?.data;
      for (let i = 0; i < stationResponse.length; i++)
        modifyStationData.push({
          key: stationResponse[i]?._id,
          name: stationResponse[i]?.name,
          phone_1: stationResponse[i]?.phone[0],
          phone_2: stationResponse[i]?.phone[1],
          action: (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              onClick={() => {
                onstationEdit(stationResponse[i]);
              }}
            >
              edit
            </a>
          ),
        });
      setData(modifyStationData);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, open]);

  const validateForm = () => {
    const newErrors: any = {};
    // Check if required fields are empty
    if (!activeStationData.name) newErrors.name = "Hub name is required.";
    if (!activeStationData.city) newErrors.city = "City is required.";
    if (!activeStationData.pincode) newErrors.pincode = "Pincode is required.";
    if (!activeStationData.email) newErrors.email = "Email is required.";
    if (activeStationData.phone.length < 2)
      newErrors.phone = "Mobile number is required.";
    if (!activeStationData.address) newErrors.address = "Address is required.";
    if (!activeStationData.landmark)
      newErrors.landmark = "Landmark is required.";
    if (!activeStationData.map) newErrors.map = "Google Map Link is required.";
    if (!activeStationData.directions)
      newErrors.directions = "directions is required.";
    if (!activeStationData.openingTime)
      newErrors.openingTime = "OpeningTime is required.";
    if (!activeStationData.closingTime)
      newErrors.closingTime = "ClosingTime is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // If no errors, return true
  };
  const saveStationData = async () => {
    let station;

    if (!validateForm()) {
      return antdMessageError("Please fill all required fields.");
    }
    if (!isValidEmail(activeStationData.email)) {
      return antdMessageError("Please Enter Valide Email");
    }

    if (mode === "create") {
      delete activeStationData._id;
      station = await API.admin.CreateStation(activeStationData);
    }
    if (mode === "edit") {
      station = await API.admin.EditStation(
        activeStationData,
        activeStationData._id as string
      );
    }

    if (!API.validators.checkSuccessCode(station as AxiosResponse<any, any>))
      return antdMessageError("unable to save right now");

    antdMessageSuccess("saved successfully");
    setOpen(false);
  };
  const handleOptionForWeekDay = (day: any) => {
    const isSelected = activeStationData.closingDays.includes(day);
    let newClosingDays;

    if (isSelected) {
      // If the day is already selected, remove it from the array
      newClosingDays = activeStationData.closingDays.filter(
        (selectedDay) => selectedDay !== day
      );
    } else {
      // If the day is not selected, add it to the array
      newClosingDays = [...activeStationData.closingDays, day];
    }

    setActiveStationData({
      ...activeStationData,
      closingDays: newClosingDays,
    });
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "16px",
        }}
      >
        <CommonButton color="primary" onClick={() => createStation()}>
          Create Hub
        </CommonButton>
      </div>

      {data?.length ? (
        <Table dataSource={data} columns={stationCol} pagination={false} />
      ) : (
        <Empty />
      )}

      <Drawer
        title="Hub Details"
        placement={"right"}
        width={520}
        onClose={onClose}
        open={open}
        closable={false}
        extra={
          <Space>
            <CommonButton color="green" onClick={() => saveStationData()}>
              Save
            </CommonButton>
            <CommonButton color="secondary" onClick={onClose}>
              Cancel
            </CommonButton>
          </Space>
        }
      >
        <div
          className={style["container"]}
          style={{ width: "470px", padding: "unset", boxShadow: "none" }}
        >
          <div className={style["wrap-inp"]}>
            <div className={style["inp-container"]}>
              <label htmlFor="name">
                Hub Name<span>*</span>
              </label>
              <Input
                value={activeStationData.name}
                name="name"
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    name: AllowInputType(e.target.value, "alphanumeric"),
                  });
                }}
                className={errors.name ? style["error-border"] : ""}
              />
            </div>
            <div
              className={style["inp-container"]}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "0px",
              }}
            >
              <div className={style["wrap-disable"]}>
                <label htmlFor="disabled" className={style["title"]}>
                  Disable
                </label>
                <Switch
                  value={activeStationData.disabled}
                  onChange={(checked) =>
                    setActiveStationData({
                      ...activeStationData,
                      disabled: checked,
                    })
                  }
                />
              </div>
            </div>
          </div>
          <div className={style["wrap-inp"]}>
            <div className={style["inp-container"]}>
              <label htmlFor="city">
                City<span>*</span>
              </label>
              <Select
                value={activeStationData.city}
                placeholder={"select city"}
                onChange={(value) => {
                  setActiveStationData({ ...activeStationData, city: value });
                }}
                options={cityData}
                className={errors.city ? style["error-border"] : ""}
                showSearch
                optionFilterProp="label"
              />
            </div>
            <div className={style["inp-container"]}>
              <label htmlFor="address">
                Address<span>*</span>
              </label>
              <Input
                value={activeStationData.address}
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    address: AllowInputType(e.target.value, "alphanumeric"),
                  });
                }}
                name="address"
                className={errors.address ? style["error-border"] : ""}
              />
            </div>
          </div>
          <div className={style["wrap-inp"]}>
            <div className={style["inp-container"]}>
              <label htmlFor="pincode">
                Pincode<span>*</span>
              </label>
              <Input
                value={activeStationData.pincode}
                name="pincode"
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    pincode: Number(AllowInputType(e.target.value, "numeric")),
                  });
                }}
                className={errors.pincode ? style["error-border"] : ""}
              />
            </div>
            <div className={style["inp-container"]}>
              <label htmlFor="commision">
                Commission %<span>*</span>
              </label>
              <InputNumber
                value={activeStationData.share}
                onChange={(value) => {
                  const numValue = Math.max(1, Math.floor(Number(value))); // Ensures value is at least 1 and removes decimals
                  setActiveStationData({
                    ...activeStationData,
                    share: numValue,
                  });
                }}
                name="commission"
                min={1} // Prevents entering numbers less than 1
                max={100}
                precision={0} // Ensures only whole numbers
                onKeyDown={handleNumericInput}
              />
            </div>
          </div>
          <div className={style["wrap-inp"]}>
            <div className={style["inp-container"]}>
              <label htmlFor="landmark">
                Landmark<span>*</span>
              </label>
              <Input
                value={activeStationData.landmark}
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    landmark: AllowInputType(e.target.value, "alphanumeric"),
                  });
                }}
                name="landmark"
                className={errors.landmark ? style["error-border"] : ""}
              />
            </div>
            <div className={style["inp-container"]}>
              <label htmlFor="mapLink">
                Google Map Link<span>*</span>
              </label>
              <Input
                value={activeStationData.map}
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    map: e.target.value,
                  });
                }}
                name="mapLink"
                className={errors.map ? style["error-border"] : ""}
              />
            </div>
          </div>
          <div className={style["wrap-inp"]}>
            <div className={style["inp-container"]}>
              <label htmlFor="directions">
                Directions<span>*</span>
              </label>
              <Input
                value={activeStationData.directions}
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    directions: AllowInputType(e.target.value, "alphanumeric"),
                  });
                }}
                name="directions"
                className={errors.directions ? style["error-border"] : ""}
              />
            </div>
            <div className={style["inp-container"]}>
              <label htmlFor="email">
                Email<span>*</span>
              </label>
              <Input
                value={activeStationData.email}
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    email: AllowInputType(
                      e.target.value,
                      "alphanumericspecialChar"
                    ),
                  });
                }}
                name="email"
                className={errors.email ? style["error-border"] : ""}
              />
            </div>
          </div>
          <div className={style["wrap-inp"]}>
            <div className={style["inp-container"]}>
              <label htmlFor="Phoneno1">
                Phone no 1<span>*</span>
              </label>
              <Input
                value={activeStationData.phone?.[0]}
                maxLength={10}
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    phone: [
                      AllowInputType(e.target.value, "numeric"),
                      activeStationData.phone?.[1],
                    ],
                  });
                }}
                name="Phoneno1"
                className={errors.phone ? style["error-border"] : ""}
              />
            </div>
            <div className={style["inp-container"]}>
              <label htmlFor="Phoneno2">
                Phone no 2<span>*</span>
              </label>
              <Input
                value={activeStationData.phone?.[1]}
                maxLength={10}
                onChange={(e) => {
                  setActiveStationData({
                    ...activeStationData,
                    phone: [
                      activeStationData.phone?.[0],
                      AllowInputType(e.target.value, "numeric"),
                    ],
                  });
                }}
                name="Phoneno2"
                className={errors.phone ? style["error-border"] : ""}
              />
            </div>
          </div>

          <h3 style={{ margin: "0px 0px -16px" }}>Hub Pricing</h3>
          <div
            className={style["day-inp-container"]}
            style={{ padding: "24px 8px 8px" }}
          >
            <div className={style["wrap-inp"]}>
              <div className={style["inp-container"]}>
                <label htmlFor="chargeupto20km">Price calculation</label>
                <Select
                  value={activeStationData.priceCalculation}
                  onChange={(value) => {
                    setActiveStationData({
                      ...activeStationData,
                      priceCalculation: value,
                    });
                  }}
                  options={[
                    { value: "HOUR", label: "Hour" },
                    { value: "DAY", label: "Day" },
                  ]}
                />
              </div>
              <div className={style["inp-container"]}>
                <div
                  className={style["wrap-disable"]}
                  style={{ marginTop: "24px" }}
                >
                  <label htmlFor="allowPartial" className={style["title"]}>
                    Partial Payment
                  </label>
                  <Switch
                    value={activeStationData.allowPartial}
                    onChange={(checked) =>
                      setActiveStationData({
                        ...activeStationData,
                        allowPartial: checked,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <h3 style={{ margin: "0px 0px -16px" }}>Hub Business Hours</h3>
          <div
            className={style["day-inp-container"]}
            style={{ padding: "24px 8px 8px" }}
          >
            <div className={style["wrap-inp"]}>
              <div className={style["inp-container"]}>
                <label htmlFor="openingTime">Opening Time</label>
                <Select
                  value={activeStationData.openingTime}
                  placeholder={"Select Time"}
                  onChange={(value) => {
                    setActiveStationData({
                      ...activeStationData,
                      openingTime: value,
                    });
                  }}
                  options={timeFormate}
                  className={errors.openingTime ? style["error-border"] : ""}
                  showSearch
                />
              </div>
              <div className={style["inp-container"]}>
                <label htmlFor="closingTime">Closing Time</label>
                <Select
                  value={activeStationData.closingTime}
                  placeholder={"Select Time"}
                  onChange={(value) => {
                    setActiveStationData({
                      ...activeStationData,
                      closingTime: value,
                    });
                  }}
                  options={timeFormate}
                  className={errors.closingTime ? style["error-border"] : ""}
                  showSearch
                />
              </div>
            </div>
            <div className={style["wrap-inp"]}>
              <div className={style["inp-container"]}>
                <label htmlFor="openingTime">Closing Day</label>
                <div className={partnerHubs["days-container"]}>
                  {WeekDays.map((option: any) => (
                    <div
                      key={option.id}
                      // className={partnerHubs["days-item"]}
                      className={`${partnerHubs["days-item"]} ${
                        activeStationData.closingDays.includes(option.id)
                          ? partnerHubs["selected-day"]
                          : ""
                      }`}
                    >
                      <div onClick={() => handleOptionForWeekDay(option.id)}>
                        {option.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <h3 style={{ margin: "0px 0px -16px" }}>
            Bike Delivery Preconditions
          </h3>
          <div
            className={style["day-inp-container"]}
            style={{ padding: "24px 8px 8px" }}
          >
            <div className={style["wrap-inp"]}>
              <div className={style["inp-container"]}>
                <label htmlFor="TeliverypreparationTime">
                  Preparation Time Before Delivery
                </label>
                <InputNumber
                  value={activeStationData.prepTime}
                  onChange={(value) => {
                    setActiveStationData({
                      ...activeStationData,
                      prepTime: Number(value),
                    });
                  }}
                  name="TeliverypreparationTime"
                  onKeyDown={handleNumericInput}
                />
              </div>
              <div className={style["inp-container"]}>
                <div
                  className={style["wrap-disable"]}
                  style={{ marginTop: "24px" }}
                >
                  <label htmlFor="delivery" className={style["title"]}>
                    Enable/Disable Delivery
                  </label>
                  <Switch
                    value={activeStationData.delivery}
                    onChange={(checked) =>
                      setActiveStationData({
                        ...activeStationData,
                        delivery: checked,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className={style["wrap-inp"]}>
              <div className={style["inp-container"]}>
                <label htmlFor="chargeupto10km">Charge UpTo 10 km</label>

                <InputNumber
                  value={activeStationData.deliveryCharge.upto10}
                  name="pincode"
                  onChange={(value) => {
                    setActiveStationData({
                      ...activeStationData,
                      deliveryCharge: {
                        ...activeStationData?.deliveryCharge,
                        upto10: Number(value),
                      },
                    });
                  }}
                  onKeyDown={handleNumericInput}
                />
              </div>
              <div className={style["inp-container"]}>
                <label htmlFor="chargeupto20km">Charge UpTo 20 km</label>
                <InputNumber
                  value={activeStationData.deliveryCharge.upto20}
                  name="pincode"
                  onChange={(value) => {
                    setActiveStationData({
                      ...activeStationData,
                      deliveryCharge: {
                        ...activeStationData?.deliveryCharge,
                        upto20: Number(value),
                      },
                    });
                  }}
                  onKeyDown={handleNumericInput}
                />
              </div>
            </div>
          </div>
          <h3 style={{ margin: "0px 0px -16px" }}>
            Terms and conditions{" "}
            <div className={style["add-more"]}>
              <div
                onClick={() => {
                  const newdata = activeStationData?.tnc;
                  newdata.push("Tnc");
                  setActiveStationData({ ...activeStationData, tnc: newdata });
                }}
              >
                Add{" "}
                <PlusCircleTwoTone
                  style={{ marginLeft: "8px" }}
                  onPointerEnterCapture={() => {}}
                  onPointerLeaveCapture={() => {}}
                />
              </div>
            </div>
          </h3>
          <div
            className={style["day-inp-container"]}
            style={{ padding: "0px 24px 24px" }}
          >
            {activeStationData?.tnc?.map((item: any, index: number) => {
              return (
                <div key={index}>
                  <div className={style["wrap-inp"]}>
                    <Input
                      style={{ marginTop: "24px", marginRight: "16px" }}
                      value={activeStationData.tnc?.[index]}
                      onChange={(e) => {
                        const array = activeStationData?.tnc;
                        array[index] = e.target.value;

                        setActiveStationData({
                          ...activeStationData,
                          tnc: array,
                        });
                      }}
                    />
                    <div
                      onClick={() => {
                        if (activeStationData?.tnc.length === 1) {
                          return antdMessageError(
                            "At least One T&C should be present"
                          );
                        }
                        setActiveStationData({
                          ...activeStationData,
                          tnc: activeStationData.tnc.filter(
                            (key: any, i: any) => index !== i
                          ),
                        });
                      }}
                      style={{ marginTop: "24px" }}
                    >
                      <DeleteTwoTone
                        onPointerEnterCapture={() => {}}
                        onPointerLeaveCapture={() => {}}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default PartnerHubs;
